module.exports = __webpack_public_path__ + "img/pointing-monk.c6749efd.svg";